import React from "react";
import {
  BookOpen,
  Briefcase,
  Building2,
  Home,
  Layers3,
  Award,
  Users,
  LogOut,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const MiniAdmin = () => {
  const navigate = useNavigate();

  const handleRedirect = (type) => {
    if (type === "blog") navigate("/blog-admin");
    if (type === "career") navigate("/admin2");

    if (type === "architectural") navigate("/architectural-admin");
    if (type === "interior") navigate("/interior-admin");
    if (type === "residential") navigate("/residential-admin");

    if (type === "awards") navigate("/awards-admin");
    if (type === "clients") navigate("/client-logo-admin");
    if (type === "teams") navigate("/team-admin");
  };

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-amber-50 to-yellow-100">
      {/* ===== HEADER ===== */}
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-yellow-200">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-800">
            Admin <span className="text-yellow-600">Dashboard</span>
          </h1>
          <button
            onClick={logout}
            className="flex items-center gap-2 text-gray-600 hover:text-red-600 transition-colors"
          >
            <LogOut size={18} /> Logout
          </button>
        </div>
      </header>

      {/* ===== MAIN ===== */}
      <main className="max-w-7xl mx-auto px-6 py-16">
        <h2 className="text-4xl font-bold text-gray-800 mb-3">
          Management Panels
        </h2>
        <p className="text-gray-600 mb-14">
          Select a section to manage your content
        </p>

        {/* ===== PANELS ===== */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {/* BLOG */}
          <Panel
            title="Blog"
            desc="Articles & posts"
            icon={<BookOpen size={36} />}
            gradient="from-yellow-400 to-amber-500"
            border="border-yellow-300"
            onClick={() => handleRedirect("blog")}
          />

          {/* CAREERS */}
          <Panel
            title="Careers"
            desc="Jobs & applicants"
            icon={<Briefcase size={36} />}
            gradient="from-indigo-500 to-purple-600"
            border="border-indigo-400"
            onClick={() => handleRedirect("career")}
          />
          {/* 
          <Panel
            title="Architecture"
            desc="Hero images & banners"
            icon={<Building2 size={36} />}
            gradient="from-orange-500 to-amber-600"
            border="border-orange-400"
            onClick={() => handleRedirect("architecture")}
          /> */}

          {/* AWARDS */}
          <Panel
            title="Awards"
            desc="Achievements & recognition"
            icon={<Award size={36} />}
            gradient="from-emerald-500 to-teal-600"
            border="border-emerald-400"
            onClick={() => handleRedirect("awards")}
          />

          {/* CLIENTS */}
          <Panel
            title="Clients"
            desc="Client logos & partners"
            icon={<Users size={36} />}
            gradient="from-amber-500 to-yellow-600"
            border="border-amber-300"
            onClick={() => handleRedirect("clients")}
          />

          {/* TEAMS */}
          <Panel
            title="Teams"
            desc="Team members"
            icon={<Users size={36} />}
            gradient="from-neutral-600 to-gray-700"
            border="border-gray-400"
            onClick={() => handleRedirect("teams")}
          />
          {/* ARCHITECTURAL PROJECTS */}
          <Panel
            title="Architectural Projects"
            desc="Manage architectural works"
            icon={<Building2 size={36} />}
            gradient="from-slate-600 to-gray-700"
            border="border-gray-400"
            onClick={() => navigate("/architectural-admin")}
          />

          {/* INTERIOR PROJECTS */}
          <Panel
            title="Interior Projects"
            desc="Manage interior designs"
            icon={<Layers3 size={36} />}
            gradient="from-rose-500 to-pink-600"
            border="border-rose-400"
            onClick={() => navigate("/interior-admin")}
          />
          <Panel
            title="Abhay Projects"
            desc="Manage residential projects"
            icon={<Layers3 size={36} />}
            gradient="from-violet-600 to-blue-600"
            border="border-violet-400"
            onClick={() => navigate("/interior-admin")}
          />
          {/* CONTACTS */}
          <Panel
            title="Contact Inquiries"
            desc="Manage contact messages"
            icon={<Home size={36} />}
            gradient="from-sky-500 to-blue-600"
            border="border-sky-400"
            onClick={() => navigate("/contact-admin")}
          />
          {/* Inquiry */}
          <Panel
            title="Project Inquiries"
            desc="Manage career messages"
            icon={<Briefcase size={36} />}
            gradient="from-green-500 to-lime-600"
            border="border-green-400"
            onClick={() => navigate("/inquiry-admin")}
          />
        </div>
      </main>
    </div>
  );
};

/* ===== PANEL COMPONENT ===== */
const Panel = ({ title, desc, icon, gradient, border, onClick }) => (
  <button
    onClick={onClick}
    className={`group relative rounded-2xl border ${border} bg-white shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1`}
  >
    <div
      className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}
    />

    <div className="relative z-10 p-8 h-full flex flex-col items-center text-center">
      <div className="mb-4 p-4 rounded-xl bg-white shadow text-gray-800 group-hover:text-white transition">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-gray-800 group-hover:text-white transition">
        {title}
      </h3>
      <p className="text-sm mt-2 text-gray-600 group-hover:text-white/90 transition">
        {desc}
      </p>
    </div>
  </button>
);

export default MiniAdmin;
